import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import Vuelidate from 'vuelidate'
import 'buefy/dist/buefy.css'
import countries from 'countries-list'

Object.defineProperty(Vue.prototype, '$countries', { value: countries })

Vue.config.productionTip = false

Vue.use(Buefy, {
  defaultIconPack: 'mdi'
})

Vue.use(Vuelidate)

new Vue({
  render: h => h(App)
}).$mount('#app')
